import React from "react"
import { H2, Stack, FlexContainer, Divider, Body, Button } from "@carrotfertility/carotene"
import { IlloPercentCircle } from "components/views/atoms/Illustrations"
import styled from "styled-components"
import L10n from "lib/carrot-l10n"
import { useHistory } from "react-router-dom"
import Locations from "components/views/home/navigation"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const StyledDivider = styled(Divider)({
  backgroundColor: "#EBEBEB",
  borderColor: "#EBEBEB",
  marginTop: 0,
  width: "100%"
})

const PrimaryButton = styled(Button)({
  marginRight: "16px"
})

type DeductibleEnrollmentReminderProps = {
  onExit: () => void
}

const DeductibleEnrollmentReminder = (props: DeductibleEnrollmentReminderProps): JSX.Element => {
  const history = useHistory()

  const onClickUpdate = (): void => history.push(Locations.Home.EnrollmentFlowActive)

  const headerMessage = l`To access your funds, tell us about your insurance`
  const bodyMessage = l`Your insurance coverage affects how Carrot funds are taxed and whether a deductible applies.`

  const secondaryButtonLabel = l`I'll do this later`
  const primaryButtonLabel = l`Share now`

  return (
    <Stack paddingTopBottom="medium" paddingLeftRight="huge">
      <IlloPercentCircle height={88} width={88} />
      <FlexContainer direction="column">
        <H2>{headerMessage}</H2>
        <Body size="small">{bodyMessage}</Body>
      </FlexContainer>
      <StyledDivider />
      <FlexContainer>
        <PrimaryButton variant="primary" onClick={onClickUpdate}>
          {primaryButtonLabel}
        </PrimaryButton>
        <Button variant="secondary" onClick={props.onExit}>
          {secondaryButtonLabel}
        </Button>
      </FlexContainer>
    </Stack>
  )
}

export default DeductibleEnrollmentReminder
